import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'EquipmentModel' })
export class EquipmentModel {
  @Key id: number;
  equipMake: string;
  equipModel: string;
  equipType: number;
}
